<template>
  <div>
    403
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>